import React from 'react';
import StudentLayout from './components/StudentLayout';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';

const progressCards = [
  {
    title: 'Classes attended',
    value: '18',
    helper: 'Out of 24 scheduled sessions',
    icon: <SchoolRoundedIcon color="primary" />,
    completion: 75,
  },
  {
    title: 'Assignments submitted',
    value: '9',
    helper: 'Keep up the good streak!',
    icon: <EmojiEventsRoundedIcon color="primary" />,
    completion: 60,
  },
  {
    title: 'Study hours logged',
    value: '32h',
    helper: 'Target 40 hours this term',
    icon: <InsightsRoundedIcon color="primary" />,
    completion: 80,
  },
];

const Progress = () => (
  <StudentLayout>
    <Box>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h4" fontWeight={800} color="primary.main">
            Progress
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Track your learning progress, view completed lessons, and monitor upcoming goals.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {progressCards.map((card) => (
            <Grid item xs={12} md={4} key={card.title}>
              <Card variant="outlined" sx={{ height: '100%' }}>
                <CardHeader
                  avatar={card.icon}
                  title={
                    <Typography variant="subtitle2" color="text.secondary">
                      {card.title}
                    </Typography>
                  }
                />
                <CardContent>
                  <Stack spacing={1.5}>
                    <Typography variant="h4" fontWeight={800}>
                      {card.value}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {card.helper}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={card.completion}
                      sx={{ height: 8, borderRadius: 999 }}
                    />
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  </StudentLayout>
);

export default Progress;
